import { tablePadding, tableSpacing } from "@core/table";
import { tokens } from "@core/theme/tokens";

// Medidas de layout extraídas literalmente de admin.jsx — DESIGN-TOKENS.md no
// define una escala de espaciado/tamaño (solo color/radio/sombra/fuente), así
// que estos números viven acá y no en @core/theme/tokens. Cada grupo cita la
// composición del prototipo de la que sale.
export const catalogStyles = {
  // AdminCatalogos (admin.jsx:3062-3091)
  master: { gridTemplateColumns: "270px minmax(0, 1fr)", gap: 20 },
  sidebar: {
    padding: 14,
    labelPadding: "0 8px 12px",
    itemPadding: "11px 13px",
    itemMarginBottom: 0,
    itemFontSize: 12.5,
  },
  header: {
    marginBottom: 22,
    titleFontSize: 28,
    subtitleMargin: "6px 0 0",
    subtitleFontSize: 13,
  },
  subheader: {
    marginBottom: 16,
    gap: 16,
    titleFontSize: 23,
    subtitleMargin: "6px 0 0",
    subtitleFontSize: 12,
  },
  // Barra de búsqueda de CatalogoGenerico (admin.jsx:2726-2727)
  search: { width: 260, padding: "9px 10px" },
  checkboxLabelFontSize: 12,
  loadingPadding: 22,
  // Cabecera + filas de la tabla genérica (admin.jsx:2743,2748)
  table: {
    gridTemplateColumns: "132px 1.3fr 1.9fr 108px 168px 168px",
    gap: tableSpacing.columnGap,
    headerPadding: tablePadding("16px", "11px"),
    headerFontSize: 11,
    rowPadding: tablePadding("12px"),
    codeFontSize: 11.5,
    nameFontSize: 12.5,
    descriptionFontSize: 12,
    useFontSize: 11.5,
  },
  // Tarjetas especializadas: modelos (admin.jsx:2802-2856) y comercios
  // (admin.jsx:3687-3781) comparten padding/gap de contenedor.
  cards: {
    gap: 14,
    padding: 18,
    modelImageHeight: 128,
    merchantLogoSize: 96,
  },
  modelGrid: { gridTemplateColumns: "repeat(auto-fill, minmax(232px, 1fr))" },
  modelCard: {
    padding: 15,
    nameFontSize: 13.5,
    metaFontSize: 11.5,
    metaMargin: "4px 0 12px",
  },
  // Filas de taller: tabla, no cards (admin.jsx:2870-2882). La columna de
  // acciones del prototipo (132px) solo aloja "Editar": esta pantalla suma
  // "Inactivar"/"Ver bloqueo" (RN-23, criterio 3 de SPEC-011 §7) que el
  // prototipo nunca ejercita con datos semilla en uso, así que la columna se
  // ensancha (190px) para no cortar el segundo botón — adaptación
  // documentada en run-step, no un valor a mano sin justificar.
  workshopTable: {
    gridTemplateColumns: "1.4fr 1fr 1.4fr 110px 190px",
    rowPadding: tablePadding("14px"),
    nameFontSize: 12.5,
    metaFontSize: 12,
  },
  // Comercio: card horizontal (admin.jsx:3704-3727)
  merchant: {
    gap: 18,
    headerGap: 10,
    headerMarginBottom: 4,
    nameFontSize: 14.5,
    metaFontSize: 12,
    metaMarginTop: 3,
    validatorsMarginTop: 13,
    validatorsGap: 8,
    emptyValidatorsFontSize: 11.5,
  },
  // Acciones del referido: preview (admin.jsx:2922-2942) + filas arrastrables
  // (admin.jsx:2985-3004)
  referral: {
    previewLabelMarginBottom: 10,
    previewPadding: "4px 2px",
    circleSize: 40,
    circleGap: 8,
    circleItemWidth: 92,
    connectorHeight: 2,
    connectorWidth: 26,
    connectorMarginBottom: 22,
    nameFontSize: 10,
    row: {
      gap: 14,
      padding: "14px 16px",
      marginBottom: 8,
      borderRadius: 14,
      orderWidth: 20,
      orderFontSize: 13,
      colorDotSize: 12,
      titleGap: 9,
      titleFontSize: 13,
      descFontSize: 11.5,
      descMarginTop: 3,
      actionsGap: 6,
    },
  },
  // Insignia de estado / acción final (star-circle.css:142-148: .stat)
  badge: {
    padding: "6px 11px",
    fontSize: 11,
    finalPadding: "3px 9px",
  },
  scrim: "rgba(0,0,0,0.5)",
  modal: { padding: 24, maxHeight: "82vh" },
  modalWidth: { generic: 520, model: 560, workshop: 620, merchant: 620 },
  panel: {
    background: tokens.surface.bg2,
    border: `1px solid ${tokens.surface.line}`,
    borderRadius: 18,
    boxShadow: tokens.shadow,
  },
  // CatalogEntryForm: inputs (admin.jsx `inp`). El horario semanal (P8-3,
  // SPEC-207) se edita solo en Agendamiento; este catálogo dejó de tener su
  // propia grilla de horas.
  form: {
    inputPadding: "9px 10px",
    fieldGap: 5,
  },
} as const;
